<script setup lang="ts">
import { Ref } from 'vue'
import { useShopBreadcrumbs } from './composables/useShopBreadcrumbs'

const props = defineProps<{
  foreignKey: string
}>()

const { search } = useCategorySearch()

const { languageCode } = useLocale()
const { setLoading } = useLoadingStore()

const { data: categoryResponse } = await useAsyncData(
  `cmsNavigation-${props.foreignKey}-${languageCode.value}`,
  async () => {
    const category = await search(props.foreignKey, {
      withCmsAssociations: false,
    })
    return category
  },
)

import type { Category } from '~/types/shopware'

const { category } = useCategory(categoryResponse as Ref<Category>)

// Clear loading after page setup is complete (similar to master branch approach)
onMounted(() => {
  setLoading(false)
})

const { breadcrumbs } = useShopBreadcrumbs(category.value)

useShopwareMetaTags(category.value)
</script>
<template>
  <Hero class="section-hero" :content="{ title: category.translated.name }" :breadcrumbs="breadcrumbs" />
  <SectionIntrotext
    v-if="category.translated.description"
    v-animate="{ animation: 'vertical-reveal' }"
    :text="category.translated.description"
  />
  <section class="section">
    <div class="grid container">
      <div class="t-10 t-o-1 tl-o-0 ds-o-1 ds-8">
        <ShopSubcategories :category="category" />
      </div>
      <ShopProductListing :category="category" />
    </div>
  </section>
</template>
<style scoped lang="scss">
:deep(.subcategories) {
  @include fluid(margin-bottom, 32px, 128px);
}
</style>
